var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 34,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M24.828 10.593A4.95 4.95 0 0027 7.86c-.956.57-2.012.98-3.136 1.2a4.94 4.94 0 00-3.607-1.56 4.94 4.94 0 00-4.81 6.07c-4.105-.2-7.742-2.17-10.182-5.16A4.928 4.928 0 004.6 10.9c0 1.72.87 3.23 2.19 4.11-.81-.02-1.57-.25-2.24-.61v.06c0 2.4 1.7 4.39 3.96 4.85-.418.12-.85.18-1.3.18-.32 0-.63-.03-.93-.08a4.946 4.946 0 004.612 3.43 9.878 9.878 0 01-6.134 2.12 9.22 9.22 0 01-1.18-.07 13.91 13.91 0 007.572 2.22c9.084 0 14.05-7.52 14.05-14.05 0-.21-.005-.43-.014-.64.965-.69 1.8-1.56 2.464-2.55-.886.397-1.84.66-2.837.78z"
  })));
}
export default SvgTwitterIcon;